var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13015.964,1494.526l5.5,5.5,5.5-5.5","transform":"translate(-13015.434 -1493.996)","fill":"none","stroke":"#1c1b1b","strokeWidth":"1.5"}));
}

ChevronDown.defaultProps = {"width":"12.067","height":"7.095","viewBox":"0 0 12.067 7.095"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
